import React, { FC } from 'react';
import ListManagementRequest from '../../components/core/RepositoryRequests/RepositoryRequests';
import ListMeRepositories from '../../components/core/ListMeRepositories/ListMeRepositories';
import ListRepositories from '../../components/core/ListRepositories/ListRepositories';
import PrimaryNavigation from '../../components/core/PrimaryNavigation/PrimaryNavigation';

import ListAdminRepositories from '../../components/core/ListAdminRepositories/ListAdminRepositories';
import NavbarAdmin from '../../components/NavBar-Admin/Navbar-Admin';
interface AdminRepositoriesProps {}

const AdminRepositories: FC<AdminRepositoriesProps> = () => (
  <div className="">
    <div className="body">
<header className="header">
<div className="header-content responsive-wrapper">
<NavbarAdmin></NavbarAdmin>
  </div>
</header>
<main>
<div className="responsive-wrapper">
<div className="main-header">
</div>

<div className="content-header">
<div className="content-header-intro">
  <br></br>
<h2 className="pds-contentTeaser-heading pds-typography-h1">&nbsp;<strong>Administracion de  Repositorios</strong></h2>

</div>
</div>
<div className='content'>
  <div className='content-main'>
    <div className='container'>
   <ListAdminRepositories></ListAdminRepositories>
    </div>
  </div>
</div>
</div>
</main>

</div>
  </div>
);

export default AdminRepositories;